/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import Filter from '../../../interfaces/forms/Filter';
import { connect } from 'react-redux';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import Pager from '../../../components/Adescom/PagerRange';
import FabAddButton from '../../../components/Buttons/FabAddButton';
import { history } from '../../../core/history';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { store } from '../../../core/store';
import { StoreHelper } from '../../../helpers/StoreHelper';
import { GeneralHelper } from '../../../helpers/GeneralHelper';
import FractionListItem from './FractionListItem';
import { defaultActions } from '../../../core/actionsDefault';
import Order from '../../../interfaces/forms/Order';
import { fractionsReducers } from '../../../modules/fractions/reducers';
import { fractionsActions, fractionsConstants } from '../../../modules/fractions/actions';
import { configDefault } from '../../../core/config';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { pricelistSchemaElementPrefixConstants } from '../../../modules/pricelists/reducers';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import FractionInterface from '../../../interfaces/billing/FractionInterface';
import AlertConfirm from '../../../components/Info/AlertConfirm';
import { FilterReducerFieldName } from '../../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../../modules/filter/FilterListReducers';
import CancelButton from '../../../components/Buttons/CancelButton';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';

interface FractionListProps {
    classes: any;
    dispatch: any;
    fractionList: any;
}

interface FractionListState {
    filters: Array<Filter>;
    orders: Array<Order>;
    fractionList: any;
    activeRow: number | null;
    alertContent: React.ReactElement | string | null;
    selectedPricelistSchemaId: number | null;
    URI: string;
}

class FractionList extends PureComponent<FractionListProps, FractionListState> {
    constructor(props: FractionListProps) {
        super(props);

        store.injectReducer('fractionsReducers', fractionsReducers);
        StoreHelper.requiresStores(this, ['fractionsReducers']);

        this.state = {
            fractionList: null,
            filters: [],
            orders: [],
            activeRow: null,
            alertContent: null,
            selectedPricelistSchemaId: null,
            URI: '/active_pricelists',
        };
    }

    componentDidMount(): void {
        const { dispatch } = this.props;
        dispatch(
            fractionsActions.getList(
                FormGeneralHelper.getUrl('/fractions', configDefault.PLATFORM_API_PREFIX),
                [],
                [{ name: 'mainname', value: 'asc' }],
                fractionsConstants.LIST,
                null,
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            )
        );
    }

    paginationCallbackFunction = (uri: string): void => {
        const { dispatch } = this.props;
        if (!uri) {
            uri = FormGeneralHelper.getPath('/fractions', configDefault.PLATFORM_API_PREFIX);
        }

        dispatch(
            defaultActions.getCollection(FormGeneralHelper.getByUri(uri), this.state.filters, this.state.orders, fractionsConstants.LIST, null, {})
        );
    };

    setActiveRow = (id: number): void => GeneralHelper.setActiveRow(id, this);

    addNewFraction = (): void => history.push(FormGeneralHelper.getRouteUrl('/fraction-add'));

    deleteFraction = (param: { id: number }): void => {
        this.setState((prevState: FractionListState) => ({
            ...prevState,
            alertContent: 'general:common.loading',
            selectedPricelistSchemaId: param.id,
        }));
        const { dispatch } = this.props;
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(this.state.URI, configDefault.PLATFORM_API_PREFIX)),
            pricelistSchemaElementPrefixConstants.DELETE,
            [
                {
                    name: 'fractionId',
                    value: param.id,
                },
            ],
            [],
            (data: any) => {
                if (data && data['hydra:member'] && data['hydra:member'].length > 0) {
                    this.setState((prevState: FractionListState) => ({
                        ...prevState,
                        alertContent: this.prepareAlertContent(data['hydra:member']),
                    }));
                } else {
                    this.setState((prevState: FractionListState) => ({
                        ...prevState,
                        alertContent: 'fractions:notify.delete_fraction',
                    }));
                }
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    };

    prepareAlertContent = (data: Array<FractionInterface>): React.ReactElement => {
        const description = (
            <Typography variant="subtitle2">
                <I18n trans={'fractions:notify.delete_fraction_active'} />
            </Typography>
        );

        const content = (
            <div style={{ marginTop: 20 }}>
                {data.map((el: FractionInterface) => {
                    return <div key={el.mainname}>{el.mainname}</div>;
                })}
            </div>
        );

        return (
            <>
                {description}
                {content}
            </>
        );
    };

    confirmDelete = (): void => {
        const { dispatch } = this.props;
        const itemLoader = new ItemLoaders(dispatch);

        this.cancelDelete();
        itemLoader.deleteCall(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/fractions/' + this.state.selectedPricelistSchemaId)),
            pricelistSchemaElementPrefixConstants.DELETE,
            (): void => {
                this.paginationCallbackFunction(FormGeneralHelper.getPath('/search_fractions/', configDefault.ES_API_PREFIX));
                NotificationHelper.notifySuccess('fractions:notify.delete_fraction_success', dispatch);
            },
            {
                dispatchAfterCallback: true,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    cancelDelete = (): void => {
        this.setState((prevState: FractionListState) => ({
            ...prevState,
            alertContent: null,
        }));
    };

    updateOrderList = (orders: Array<Order>): void => {
        this.setState({
            ...this.state,
            orders: orders,
        });
    };
    updateFilterList = (filters: Array<Filter>): void => {
        this.setState({
            ...this.state,
            filters: filters,
        });
    };

    clearFilter = (): void => {
        const { dispatch } = this.props;
        dispatch({
            type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            clearAll: true,
        });
        dispatch({
            type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
        });
    };

    setDefaultFilter = (callback: any): void => {
        this.setState({
            ...this.state,
            orders: [],
            filters: [],
        });
        callback();
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, fractionList } = this.props;
        const { activeRow } = this.state;
        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableCellRoot = { root: classes.tableCellRoot };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.paginationCallbackFunction}
                                        callbackParam={null}
                                        size={'lg'}
                                        color="primary"
                                        label="general:common.search"
                                    />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} padding="none" align="left">
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                    {(this.state.orders.length > 0 || this.state.filters.length > 0) && (
                                        <CancelButton
                                            callback={(): void => this.setDefaultFilter(this.clearFilter)}
                                            callbackParam={{}}
                                            tooltipTitle="general:common.clear_filter"
                                        />
                                    )}
                                </TableCell>
                                <TableCell classes={tableStickyHeader} align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="fractions:f.fraction"
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        fieldName="mainname"
                                        showSort={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={this.state.filters}
                                        sort={this.state.orders}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fractionList &&
                                fractionList['hydra:member'] &&
                                fractionList['hydra:member'].map((item: any): any => {
                                    return (
                                        <FractionListItem
                                            item={item}
                                            key={'analytics_account_' + item.id}
                                            activeRow={activeRow}
                                            setActiveRow={this.setActiveRow}
                                            deleteFraction={this.deleteFraction}
                                        />
                                    );
                                })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell classes={tableCellRoot} colSpan={25}>
                                    {fractionList && fractionList['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={fractionList} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                    <FabAddButton callback={this.addNewFraction} />
                    {this.state.alertContent && (
                        <AlertConfirm
                            onConfirm={this.confirmDelete}
                            onCancel={this.cancelDelete}
                            confirmBtnText={'general:common.confirm'}
                            cancelBtnText={'general:common.cancel'}
                            content={this.state.alertContent}
                        />
                    )}
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): object => {
    const { fractionsReducers } = state;
    if (!fractionsReducers) {
        return {};
    }
    let list = null;
    let type = null;
    if (fractionsReducers) {
        if (fractionsReducers.collections) {
            list = fractionsReducers.collections;
        }
        if (fractionsReducers.type) {
            type = fractionsReducers.type;
        }
    }
    return {
        type: type,
        fractionList: list,
    };
};

const enhance = compose<any, any>(connect(mapStateToProps), withStyles(oplAppStyle));
export default enhance(FractionList);
